// tslint:disable:max-line-length

import React from 'react';

export const ActionAdd = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="15,6.5 9.5,6.5 9.5,1 6.5,1 6.5,6.5 1,6.5 1,9.5 6.5,9.5 6.5,15 9.5,15 9.5,9.5 15,9.5" />
    </svg>
  );
};
